module.exports = __webpack_public_path__ + "img/ck.0d627c1f.svg";